var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4166 3.70013H9.61995C7.54776 3.70013 6.51166 3.70013 5.72019 4.10341C5.02399 4.45814 4.45796 5.02417 4.10323 5.72037C3.69995 6.51184 3.69995 7.54794 3.69995 9.62013V19.9801C3.69995 22.0523 3.69995 23.0884 4.10323 23.8799C4.45796 24.5761 5.02399 25.1421 5.72019 25.4969C6.51166 25.9001 7.54776 25.9001 9.61995 25.9001H20.9666C22.1136 25.9001 22.6871 25.9001 23.1576 25.7741C24.4344 25.4319 25.4317 24.4346 25.7739 23.1578C25.9 22.6872 25.9 22.1138 25.9 20.9668M23.4333 9.8668V2.4668M19.7333 6.1668H27.1333M12.95 10.4835C12.95 11.8458 11.8456 12.9501 10.4833 12.9501C9.12098 12.9501 8.01662 11.8458 8.01662 10.4835C8.01662 9.12116 9.12098 8.0168 10.4833 8.0168C11.8456 8.0168 12.95 9.12116 12.95 10.4835ZM18.4877 14.6992L8.05503 24.1834C7.46823 24.7168 7.17483 24.9836 7.14888 25.2146C7.12638 25.4149 7.20318 25.6136 7.35455 25.7466C7.52918 25.9001 7.9257 25.9001 8.71874 25.9001H20.2957C22.0706 25.9001 22.9581 25.9001 23.6552 25.6019C24.5303 25.2276 25.2274 24.5304 25.6018 23.6554C25.9 22.9583 25.9 22.0708 25.9 20.2958C25.9 19.6986 25.9 19.4 25.8347 19.1219C25.7526 18.7724 25.5953 18.4451 25.3736 18.1627C25.1973 17.938 24.9641 17.7514 24.4977 17.3784L21.0478 14.6184C20.5811 14.245 20.3477 14.0583 20.0907 13.9924C19.8642 13.9344 19.6258 13.9419 19.4034 14.0141C19.1511 14.0961 18.9299 14.2971 18.4877 14.6992Z",
    stroke: "#1672BA",
    strokeWidth: 2.46667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlus);
export default __webpack_public_path__ + "static/media/image-plus.6d3f865506dd401ff98039a5554c8234.svg";
export { ForwardRef as ReactComponent };